import { FC } from 'react';
import { TableHeaderCell } from '../../../../components/Table/TableHeaderCell/TableHeaderCell';
import { getArrangesInitialValues } from '../../../../lib/utils/arranges-helpers';
import { useArrangeSubmit } from '../../helpers/useArrangeSubmit';
import { ArrangeDatePopup } from '../popups/ArrangeDatePopup';

type Props = {
  arrangedId?: string;
  title?: string;
  removeFilter?: () => void;
  //eslint-disable-next-line
  sortOrder?: any;
  //eslint-disable-next-line
  isActiveArrange?: any;
  //eslint-disable-next-line
  form?: any;
  //eslint-disable-next-line
  applyArranges?: any;
  //eslint-disable-next-line
  rootProps?: any;
  //eslint-disable-next-line
  filterLabel?: any;
};

export const DateHeaderCell: FC<Props> = ({
  arrangedId,
  title,
  removeFilter,
  sortOrder,
  isActiveArrange,
  form,
  applyArranges,
  rootProps,
  filterLabel,
}) => {
  const { onFinish } = useArrangeSubmit(applyArranges);

  return (
    <TableHeaderCell
      title={title}
      arrangedId={arrangedId}
      filterLabel={filterLabel}
      removeFilter={removeFilter}
      sortOrder={sortOrder}
      isActiveArrange={isActiveArrange}
      form={form}
      rootProps={rootProps}
    >
      <ArrangeDatePopup
        initialValues={getArrangesInitialValues(form)}
        form={form}
        onFinish={onFinish}
        isActiveArrange={isActiveArrange}
      />
    </TableHeaderCell>
  );
};
